import axios from "axios";
import Cookies from "js-cookie";
import MockAdapter from "axios-mock-adapter";
import { MockEndPoints } from "@/__server__";
const api = axios.create({
  baseURL: process.env.API_HOST,
});

// Request interceptor: agrega token
api.interceptors.request.use(
  async (config) => {
    let token;

    if (typeof window === "undefined") {
      // Server-side
      try {
        const { cookies } = require("next/headers");
        const tokenObj = await cookies();
        token = tokenObj.get("tokend2g")?.value;
      } catch (err) {
        console.warn("No se pudieron leer cookies en server:", err);
      }
    } else {
      // Client-side
      token = Cookies.get("tokend2g");
    }

    if (token) {
      config.headers.Authorization = `${token}`;
      config.headers["Accept"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Whitelist de endpoints que no requieren redirección
const whitelist = ["/api/login"];

// Response interceptor: maneja 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      !whitelist.includes(error.config.url)
    ) {
      if (typeof window !== "undefined") {
        // Client-side: eliminar token y redirigir
        Cookies.remove("tokend2g");
        localStorage.removeItem("auth");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);


export const Mock = new MockAdapter(api);
MockEndPoints(Mock);

export default api;
